import { getLastDecimalNumberUtil } from '../../number/get-last-decimal'
import sortByArrayUtil from 'packages/src/modules/array/sort-by'

export default function shuffleArrayUtil (arr, seed = ((new Date()).getTime() / 10000000)) {
  return sortByArrayUtil(
    arr, id => {
      if (!Number.isFinite(id)) {
        return id * -1
      }
      return getLastDecimalNumberUtil(id / seed)
    }
  )
}
